//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Die.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/Section.js";
import "../no/Expression.js";
import "../Die/Die.DieDirectionBuilder.js";
import "../Die/Die.DieLocationBuilder.js";
import "../Die/Die.DrawBeadTaperBuilder.js";
import "../Die/Die.DieAttributesBuilder.js";
import "../no/ScCollector.js";
import "../Die/Die.DrawBeadSegmentBuilderList.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
import "../no/Section.js";
import "../no/ObjectList.js";
let d=[[[0,"AngleTolerance",1,0],[0,"BaseOrientation",1,0],[0,"BuildEndTaper",1,0],[0,"BuildStartTaper",1,0],[1,"Centerline",0,"Section",0],[0,"CenterlineProjection",1,0],[1,"Clearance",0,"Expression",0],[0,"DistanceTolerance",1,0],[1,"DrawDirection",0,"Die.DieDirectionBuilder",0],[1,"EndPoint",0,"Die.DieLocationBuilder",0],[1,"EndTaper",0,"Die.DrawBeadTaperBuilder",0],[0,"FemaleDepthType",1,0],[1,"FemaleDepthValue",0,"Expression",0],[1,"FemaleFaceAttribute",0,"Die.DieAttributesBuilder",0],[1,"FemaleSheetAttribute",0,"Die.DieAttributesBuilder",0],[0,"FemaleWidthType",1,0],[1,"FemaleWidthValue",0,"Expression",0],[0,"GenerateHeightCurve",1,0],[0,"MachineOffset",1,0],[1,"MachiningOffsetTitleAttribute",0,"Die.DieAttributesBuilder",0],[0,"MaleBeadPosition",1,0],[1,"MaleFaceAttribute",0,"Die.DieAttributesBuilder",0],[1,"MaleSheetAttribute",0,"Die.DieAttributesBuilder",0],[1,"MetalThickness",0,"Expression",0],[0,"OrientSectionToDraw",1,0],[0,"Output",1,0],[1,"PlacementFace",0,"ScCollector",0],[0,"ReferenceDirection",1,0],[0,"ReverseMetalThickness",1,0],[1,"SegmentList",0,"Die.DrawBeadSegmentBuilderList",0],[1,"SheetMetalFaceAttribute",0,"Die.DieAttributesBuilder",0],[1,"SheetMetalSheetAttribute",0,"Die.DieAttributesBuilder",0],[1,"StartPoint",0,"Die.DieLocationBuilder",0],[1,"StartTaper",0,"Die.DrawBeadTaperBuilder",0],[0,"TaperBead",1,0],[0,"TransitionDefinition",1,0]],[[[],"CreateSegmentsFromCenterlineCurves",{},0,0],[[],"CreateDrawBeadSegment",{R_:{item:"Die.DrawBeadSegmentBuilder"}},0,0],[[],"SetDefaultDrawDirection",{},0,0],[["strings"],"SetMoreDetails",{},1,0],[["num_strings"],"GetMoreDetails",{R_:{strings:""}},0,0]],[]];
SPLM.Die.DrawBeadBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Die.DrawBeadBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Die.DrawBeadBuilder.MaleBeadPositionTypes = Object.freeze({
    "Upper" : "Upper", "Lower" : "Lower"});

SPLM.Die.DrawBeadBuilder.ProjectionDirectionTypes = Object.freeze({
    "DrawDirection" : "DrawDirection", "NormalToPlacementFace" : "NormalToPlacementFace"});

SPLM.Die.DrawBeadBuilder.OrientationTypes = Object.freeze({
    "Orthogonal" : "Orthogonal", "Vertical" : "Vertical"});

SPLM.Die.DrawBeadBuilder.TransitionDefinitionTypes = Object.freeze({
    "Automatic" : "Automatic", "Manual" : "Manual"});

SPLM.Die.DrawBeadBuilder.FemaleDepthTypes = Object.freeze({
    "Derived" : "Derived", "Constant" : "Constant"});

SPLM.Die.DrawBeadBuilder.FemaleWidthTypes = Object.freeze({
    "Derived" : "Derived", "Constant" : "Constant"});

SPLM.Die.DrawBeadBuilder.OutputTypes = Object.freeze({
    "None" : "None", "Male" : "Male", "PlusFemale" : "PlusFemale", "PlusSheetMetal" : "PlusSheetMetal"});

SPLM.Die.DrawBeadBuilder.OrientSectionToDrawTypes = Object.freeze({
    "DrawDirection" : "DrawDirection", "SheetMetalNormal" : "SheetMetalNormal"});

export default SPLM;